import _extends from "@babel/runtime/helpers/extends";
/*
 *                     NOTICE
 *            COPYRIGHT 2025 Ab Initio
 *       UNPUBLISHED - ALL RIGHTS RESERVED
 * 
 * This program is confidential and a trade secret of Ab Initio.
 * The receipt or possession of this program does not convey any
 * rights to reproduce or disclose its contents, or to manufacture,
 * use or sell anything that it may describe, in whole or in part,
 * without the specific written consent of Ab Initio.
 */

import { AbCheckboxGroup } from "abreact/input/AbCheckboxGroup";
import { AbDialog } from "abreact/popup/AbDialog";
import React from "react";
import { PopupManager } from "abreact/popup/PopupManager";
import { BrowserUtils } from "abweb/utils/BrowserUtils";
import { EasterEggs } from "abreact/app/easterEggs/EasterEggs";
import { AbEnriched } from "abreact/utils/enrichment/AbEnriched";
import { AbSet } from "abweb/collection/AbSet";
import { AbWebServices } from "abweb/service/AbWebServices";

/**
 * Utility for showing the Easter egg dialog
 */
export const showEasterEggDialog = () => {
  PopupManager.show(/*#__PURE__*/React.createElement(AbEasterEggDialog, null));
};

/**
 * The Easter egg dialog component. For internal use only!
 */
const AbEasterEggDialog = () => {
  const enabledEasterEggs = () => {
    const enabledEasterEggs = new AbSet();
    EasterEggs.get().forEach(easterEgg => {
      if (easterEgg.isEnabled()) {
        enabledEasterEggs.add(easterEgg);
      }
    });
    return enabledEasterEggs;
  };
  const [value, setValue] = React.useState(enabledEasterEggs);
  const hasChanges = value.symmetricDifference(enabledEasterEggs()).size > 0;
  const updateEasterEggEnablement = requestedEnabledEasterEggs => {
    const currentEnabledEasterEggs = enabledEasterEggs();

    // Enable any easter eggs that are newly enabled
    const easterEggsToEnable = requestedEnabledEasterEggs.difference(currentEnabledEasterEggs);
    easterEggsToEnable.forEach(easterEgg => {
      easterEgg.setEnabled(true);
    });

    // Disable any easter eggs that are newly disabled
    const easterEggsToDisable = currentEnabledEasterEggs.difference(requestedEnabledEasterEggs);
    easterEggsToDisable.forEach(easterEgg => {
      easterEgg.setEnabled(false);
    });
    return true;
  };
  const onSubmit = async () => {
    const updated = updateEasterEggEnablement(value);
    // Reload the page, to force the page to re-render with the new theme's images, CSS etc
    if (updated) BrowserUtils.locationReload();
    return true;
  };
  return /*#__PURE__*/React.createElement(AbDialog, {
    onSubmit: onSubmit,
    title: `${AbWebServices.sessionData.productInfo.name} Easter Eggs`,
    submitButtonProps: {
      disabled: !hasChanges
    }
  }, /*#__PURE__*/React.createElement(AbEasterEggPicker, {
    value: value,
    onChange: setValue
  }));
};
const AbEasterEggPicker = props => {
  const easterEggs = EasterEggs.get().filter(easterEgg => easterEgg.isAvailable()).sort((easterEgg1, easterEgg2) => easterEgg1.displayName.localeCompare(easterEgg2.displayName)).map(easterEgg => {
    return AbEnriched.create(easterEgg, {
      displayName: easterEgg.displayName,
      tooltip: easterEgg.description
    });
  });
  return /*#__PURE__*/React.createElement(AbCheckboxGroup, _extends({
    items: easterEggs
  }, props));
};
//# sourceMappingURL=AbEasterEggDialog.js.map
